import React, { ReactNode } from 'react';

export interface CalloutCtaProps {
  title?: string;
  cta?: ReactNode;
}

export const CalloutCta = ({ title, cta }: CalloutCtaProps) => {
  return (
    <div className='flex flex-row gap-16 p-8 pl-16 items-center bg-white rounded-[8px] w-fit'>
      <div className={'md:text-[18px]'}>{title}</div>
      <div>{cta}</div>
    </div>
  );
};
